export default __webpack_public_path__ + "static/media/patterns-no-6.7bcfa754.ogg";